module.exports = {
      id: "followus-usage",
      viewBox: "0 0 49 40",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#followus",
      toString: function () {
        return this.url;
      }
    }